<template>
  <div class="project-card-container">
    <el-row v-if="projectList.length" :gutter="16" :justify="'start'">
      <el-col v-for="p in projectList" :key="p.id" :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="form-item-card">
        <el-card :key="p.id" class="card" :class="{ single: isSingle }" :body-style="{ padding: '5px' }">
          <div class="card-content">
            <div class="card-head">
              <div class="type-icon" :style="{ backgroundColor: getType(p.type).color }">
                <!-- 支持 SVG Symbol 图标或 Element 图标 -->
                <svg v-if="getTypeIcon(p.type).isSvg" class="svg-icon" aria-hidden="true">
                  <use :xlink:href="'#' + getTypeIcon(p.type).icon"></use>
                </svg>
                <i v-else :class="getTypeIcon(p.type).icon"></i>
              </div>
              <div class="title-area">
                <div class="title">{{ p.textName | stripHtml }}</div>
                <div class="card-time">创建时间：{{ p.createTime | formatDate }}</div>
              </div>
              <div class="status-pill" :class="p.status == 2 ? 'status-publish' : 'status-unpublish'">
                {{ p.status == 2 ? '已发布' : '未发布' }}
              </div>
            </div>
            <div class="card-actions">
              <el-tooltip content="编辑" placement="bottom"><i class="el-icon-edit-outline" @click="toProjectHandle(p, 'editor')"></i></el-tooltip>
              <el-tooltip content="设置" placement="bottom"><i class="el-icon-setting" @click="toProjectHandle(p, 'settings')"></i></el-tooltip>
              <el-tooltip content="发布" placement="bottom"><i class="el-icon-s-promotion" @click="toProjectHandle(p, 'publish')"></i></el-tooltip>
              <el-tooltip content="统计" placement="bottom"><i class="el-icon-data-analysis" @click="toProjectHandle(p, 'statistics')"></i></el-tooltip>
              <el-tooltip content="分享" placement="bottom"><i class="el-icon-share" @click="toProjectHandle(p, 'share')"></i></el-tooltip>
              <el-dropdown class="more" trigger="click" @command="(cmd)=>onMore(cmd,p)">
                <span class="el-dropdown-link"><i class="el-icon-more"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="delete"><i class="el-icon-delete"></i> 删除</el-dropdown-item>
                  <el-dropdown-item command="stats"><i class="el-icon-data-analysis"></i> 统计</el-dropdown-item>
                  <el-dropdown-item command="move"><i class="el-icon-rank"></i> 移动</el-dropdown-item>
                  <el-dropdown-item command="pin"><i class="el-icon-thumb"></i> 置顶</el-dropdown-item>
                  <el-dropdown-item command="copy"><i class="el-icon-document-copy"></i> 复制</el-dropdown-item>
                  <el-dropdown-item v-if="hasBzmjPermission" command="portal"><i class="el-icon-user"></i> 客户门户</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div v-else class="empty">暂无数据</div>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'FormCardList',
  components: {},
  mixins: [mixin],
  props: {
    projectList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 我的表单页还是协作页区分 默认为表单页 协作页某些内容不显示
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false
    }
  },
  filters: {
    // 去除HTML标签并截断
    stripHtml(html) {
      if (!html) return ''
      const text = html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').trim()
      // 超过8个字符截断
      return text.length > 8 ? text.substring(0, 8) + '...' : text
    }
  },
  computed: {
    isSingle(){
      return this.projectList && this.projectList.length === 1
    },
    getStatusColorStyle() {
      return function (code) {
        let color = this.projectStatusList.find((item) => item.code == code).color
        return {
          backgroundColor: color,
          borderColor: color
        }
      }
    },
    getFormStatusName() {
      return function (code) {
        let name = this.projectStatusList.find((item) => item.code == code).name
        let statusColor = this.projectStatusList.find((item) => item.code == code).color
        return {
          statusName: name,
          color: statusColor
        }
      }
    }
  },
  methods: {
    getTypeIcon(t){
      const type = parseInt(t) || 0
      // 考试测评 - SVG图标
      if(type===3) return { isSvg: true, icon: 'icon-kaoshi' }
      // 360评估 - SVG图标
      if(type===4) return { isSvg: true, icon: 'icon-pingguchaxun' }
      // 收集表单
      if(type===2) return { isSvg: false, icon: 'el-icon-document-copy' }
      // 默认问卷调查
      return { isSvg: false, icon: 'el-icon-edit-outline' }
    },
    deleteFrom(key) {
      this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.logicDeleteForm(key)
        })
        .catch(() => {})
    },
    onMore(cmd,p){
      if(cmd==='delete') return this.deleteFrom(p.id)
      if(cmd==='stats') return this.toProjectHandle(p,'statistics')
      if(cmd==='analysis') return this.toProjectHandle(p,'analysis')
      if(cmd==='copy') return this.handleCopyForm(p.formKey)
      if(cmd==='pin') return this.$message.success('已置顶')
      if(cmd==='move') return this.$message.success('移动到文件夹')
      if(cmd==='portal') return window.location.href = `/bzmj?formKey=${p.formKey}`
    },
    endEvent(event) {
      console.log(event)
    }
  }
}
</script>

<style lang="scss" scoped>
.project-card-container {
  margin: 20px 0;

  .el-card { border-radius: 14px; position: relative; }

  .el-col {
    margin-bottom: 10px;
    text-align: left;
  
    .form-type {
      color: white;
      font-size: 11px;
      padding: 3px 5px;
      border-radius: 5px;
    }

    .status {
      text-align: left;
    }

    .status-tag {
      display: inline-block;
      width: 7px;
      height: 7px;
      line-height: 20px;
      background-color: rgba(0, 110, 255, 100);
      text-align: center;
      border: 1px solid rgba(0, 110, 255, 100);
      border-radius: 20px;
      margin-bottom: 0px;
      margin-left: 10px;
    }

    .status-name {
      margin-left: 6px;
      font-size: 11px;
    }

    .title {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.4;
      letter-spacing: 0;
      color: rgb(61, 61, 61);
      margin-left: 0;
      width: 115px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      white-space: normal;
      text-align: left;
    }

    .card-time-div {
      text-align: left;
      margin-top: 5px;
    }

    .card-time {
      text-align: left;
      font-size: 10px;
      font-weight: 400;
      line-height: normal;
      letter-spacing: 0;
      color: rgb(132, 132, 132);
      white-space: nowrap;
      width: 100%;
      margin-left: 0;
    }

    .time {
      color: rgba(144, 147, 153, 100);
      font-size: 12px;
      line-height: 20px;
      text-align: center;
      margin: 0;
    }

    img {
      width: 143px;
      height: 121px;
    }

    .folder-img {
      width: 60px;
      height: 59px;
      margin: 0 auto;
      display: inline-block;
    }

    .folder-img + .time {
      margin-top: 20px;
    }

    .btns {
      color: rgba(144, 147, 153, 100);
      position: absolute;
      width: 100%;
      margin: 0;
      padding: 0;
      bottom: 0;
      display: block;
      border: none;
      text-align: center;
    }

    .el-button--text {
      font-weight: normal;
      color: #c0c4cc;
    }

    .el-button--text:hover {
      color: #409eff;
    }

    .split-line {
      text-align: center;
      margin-top: 100px;
      width: 100%;
      border-bottom: 1px solid #e7e7e7;
    }

    &:hover .btns {
      display: block;
    }
  }
}

/* 卡片主体样式 - 固定宽度 */
.card{ 
  border-radius: 16px; 
  box-shadow: 0 2px 12px rgba(0,0,0,0.08); 
  width: 100%; 
  height: auto; 
  min-height: 140px;
  transition: all .3s ease; 
  overflow: visible;
  background: #fff; 
  display: flex;
  border: 1px solid #f0f0f0;
}
.card:hover{ 
  box-shadow: 0 4px 16px rgba(0,0,0,0.12); 
  transform: translateY(-2px);
}
.card.single{ width: 100%; }
.form-item-card{ 
  margin-left: 0; 
  margin-bottom: 16px; 
  min-width: 240px;
  max-width: 280px;
  flex: 1;
}

/* 卡片内容区 */
.card-content{ 
  height: 100%; 
  width: 100%; 
  display: flex; 
  flex-direction: column; 
  justify-content: space-between;
  padding: 16px;
}

/* 卡片头部 */
.card-head{ 
  display: flex; 
  align-items: flex-start; 
  position: relative;
  padding-right: 60px; /* 为状态标签留空间 */
}

/* 图标样式 - 圆角矩形 */
.type-icon{ 
  width: 48px; 
  height: 48px; 
  border-radius: 12px; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  color: #fff; 
  font-size: 22px;
  margin-right: 14px;
  flex-shrink: 0;
  background: linear-gradient(135deg, #6E9BF5 0%, #5B7FD6 100%);
}
.type-icon .svg-icon {
  width: 22px;
  height: 22px;
  fill: #fff;
}

/* 标题区域 */
.title-area{ 
  flex: 1; 
  min-width: 0;
}
.title{ 
  font-size: 15px; 
  color: #303133; 
  font-weight: 600; 
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 120px;
}
.card-time{ 
  font-size: 12px; 
  color: #909399; 
  margin-top: 6px;
}

/* 状态标签 - 右上角 */
.status-pill{ 
  font-size: 12px; 
  font-weight: 500; 
  text-align: center; 
  padding: 4px 10px; 
  border-radius: 10px; 
  position: absolute; 
  top: 0; 
  right: 0;
  white-space: nowrap;
}
.status-unpublish{ 
  background: #EEF3FE; 
  color: #5B7FD6;
}
.status-publish{ 
  background: #E9F7EC; 
  color: #67C23A;
}

/* 底部操作栏 */
.card-actions{ 
  display: flex; 
  align-items: center; 
  gap: 20px; 
  margin-top: 14px; 
  font-size: 18px; 
  color: #C0C4CC;
  padding-top: 12px;
  border-top: 1px solid #f5f5f5;
}
.card-actions i{ 
  cursor: pointer; 
  transition: color .2s;
}
.card-actions i:hover{ 
  color: #409EFF;
}
.more{ 
  margin-left: auto;
}
.empty{ 
  padding: 40px; 
  text-align: center; 
  color: #909399;
}
::v-deep .el-card{ margin-bottom: 0; }
::v-deep .el-card__body{ padding: 0 !important; }

/* 响应式布局 - 使用 flex wrap */
.el-row {
  display: flex !important;
  flex-wrap: wrap !important;
}
.form-item-card {
  flex: 0 0 auto !important;
  width: 300px !important;
}
@media only screen and (min-width: 1920px){
  .form-item-card {
    width: 320px !important;
  }
}
</style>
